/* ============================================================================
 *  STATE — Souscription Assurance Maladie
 * ==========================================================================*/

let _uid = 0;
const genId = (prefix) =>
  `${prefix}-${Date.now().toString(36)}-${(_uid++).toString(36)}`;

/** Personne assurée (adhérent OU affilié). */
export const buildInsured = (type = "enfant") => ({
  id: genId(type),
  type, // 'adherent' | 'conjoint' | 'enfant'
  // ── Identité (obligatoires : nom, prénoms, naissance, sexe) ──
  lastName: "",
  firstName: "",
  birthDate: "",
  sex: "", // 'M' | 'F'
  // ── Téléphone (obligatoire UNIQUEMENT pour l'adhérent) ──
  phoneDial: "+229",
  phoneNumber: "",
  // ── Optionnels ──
  email: "",
  address: "",
  profession: "",
  // ── Questionnaire médical ──
  afflictionCodes: [], // string[] de codes d'affections
  afflictionAutre: "", // précision si 'AUTRE' coché
  medications: [], // string[] (tags libres)
});

/** Adhérent principal : id fixe pour un mapping fichiers stable. */
export const buildAdherent = () => ({
  ...buildInsured("adherent"),
  id: "adherent",
});

export const buildEmptyState = () => ({
  currentStep: 0, // 0: adhérent · 1: affiliés · 2: récap/déclaration
  appPhase: "form", // 'form' | 'success'
  submissionRef: "",

  form: {
    adherent: buildAdherent(),
    affiliations: [], // liste illimitée de conjoint/enfants
    // Déclaration digitale finale
    declarationName: "", // "Je soussigné(e) ..."
    declarationAccepted: false,
    consentData: false,
  },

  // Onglet affilié actif (index dans affiliations)
  activeAffiliationIndex: 0,

  // Fichiers hors state sérialisable — indexés par id de personne
  // files[personId] = { photo: File|null, acte: File|null }
  files: {},

  errors: {
    adherent: {},
    affiliations: [], // tableau parallèle à form.affiliations
    declaration: "",
    submit: "",
  },

  loading: { submit: false },
});

export default buildEmptyState();
